// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sensorListTableHead__TijQz {
  font-size: 11px;
  font-weight: 400;
  line-height: 12px;
  color: var(--tables-title-text);
  text-transform: uppercase;
  padding: 16px 25px;
  display: flex;
  border-bottom: 1px solid var(--tables-title-stroke);
  background-color: var(--tables-title-surface);
}
@media (max-width: 810px) {
  .sensorListTableHead__TijQz {
    padding: 16px 15px;
  }
}

.sensorListTableDescription__DlDZu {
  width: 20%;
  min-width: 180px;
}
@media (max-width: 810px) {
  .sensorListTableDescription__DlDZu {
    min-width: unset;
    max-width: 150px;
    width: 100%;
  }
}

.sensorListTableCode__DGFnj {
  width: 10%;
}
@media (max-width: 810px) {
  .sensorListTableCode__DGFnj {
    width: 30%;
  }
}

.sensorListTableStatus__F57qg {
  width: 50%;
}

.sensorListTableType__VMRnj {
  width: 20%;
  min-width: 120px;
}

.sensorListTableLink__hITy3 {
  width: 10%;
}`, "",{"version":3,"sources":["webpack://./../src/pages/SensorsList/components/SensorListTableHead/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mDAAA;EACA,6CAAA;AAzEF;AA2EE;EAXF;IAYI,kBAAA;EAxEF;AACF;;AA2EA;EACE,UAAA;EACA,gBAAA;AAxEF;AAyEE;EAHF;IAII,gBAAA;IACA,gBAAA;IACA,WAAA;EAtEF;AACF;;AAyEA;EACE,UAAA;AAtEF;AAuEE;EAFF;IAGI,UAAA;EApEF;AACF;;AAuEA;EACE,UAAA;AApEF;;AAuEA;EACE,UAAA;EACA,gBAAA;AApEF;;AAuEA;EACE,UAAA;AApEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.sensorListTableHead {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--tables-title-text);\n  text-transform: uppercase;\n  padding: 16px 25px;\n  display: flex;\n  border-bottom: 1px solid var(--tables-title-stroke);\n  background-color: var(--tables-title-surface);\n\n  @media (max-width: 810px) {\n    padding: 16px 15px;\n  }\n}\n\n.sensorListTableDescription {\n  width: 20%;\n  min-width: 180px;\n  @media (max-width: 810px) {\n    min-width: unset;\n    max-width: 150px;\n    width: 100%;\n  }\n}\n\n.sensorListTableCode {\n  width: 10%;\n  @media (max-width: 810px) {\n    width: 30%;\n  }\n}\n\n.sensorListTableStatus {\n  width: 50%;\n}\n\n.sensorListTableType {\n  width: 20%;\n  min-width: 120px;\n}\n\n.sensorListTableLink {\n  width: 10%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sensorListTableHead": `sensorListTableHead__TijQz`,
	"sensorListTableDescription": `sensorListTableDescription__DlDZu`,
	"sensorListTableCode": `sensorListTableCode__DGFnj`,
	"sensorListTableStatus": `sensorListTableStatus__F57qg`,
	"sensorListTableType": `sensorListTableType__VMRnj`,
	"sensorListTableLink": `sensorListTableLink__hITy3`
};
module.exports = ___CSS_LOADER_EXPORT___;
